import axios from "axios";
import { Toast } from "../../util/Toast";
import { GET_SETTING, UPDATE_SETTING, UPDATE_GAME_STATUS } from "./types";

export const getSetting = () => (dispatch) => {
  axios
    .get("setting")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_SETTING, payload: res.data.setting });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const updateSetting = (settingId, data) => (dispatch) => {
  debugger
  axios
    .patch(`setting/${settingId}`, data)
    .then((res) => {
      if (res.data.status) {
        debugger
        dispatch({ type: GET_SETTING, payload: res.data.setting });
        Toast("success", "Updated Successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const handleSwitch = (settingId, type) => (dispatch) => {
  axios
    .put(`setting/${settingId}?type=${type}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_SETTING, payload: res.data.setting });
        Toast("success", "Updated Successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const updateGameStatus = (settingId, gameName) => (dispatch) => {
  console.log("Updating game status for:", gameName);
  axios
    .post(`setting/${settingId}/gameStatus`, { gameName })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_GAME_STATUS, payload: res.data.setting });
        Toast("success", "Game status updated successfully!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
